import { MachineGroupScheduleTimeRange } from './calendar/machine-group-schedule-time-range';
import { MachineGroupSection } from './machine-group-section';
import { Model } from './model';
export class MachineGroup {
  constructor(
    public hash?: string,
    public name?: string,
    public models?: Model[],
    public machineGroupScheduleTimeRanges?: MachineGroupScheduleTimeRange[],
    public sections?: MachineGroupSection[],
  ) { }

  clone() {
    return new MachineGroup (
      this.hash,
      this.name,
      this.models,
      this.machineGroupScheduleTimeRanges,
      this.sections,
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/machine-group.ts